import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAccount } from '../contexts/AccountContext';
import { firstAccessibleRoute, type Domain } from '../domain/access';

interface RequireDomainProps {
  domain: Domain;
  children: ReactNode;
}

/**
 * Garde de route par domaine fonctionnel. Sans le domaine, on renvoie vers la
 * première page accessible (jamais vers une page interdite : pas de boucle).
 */
export const RequireDomain = ({ domain, children }: RequireDomainProps) => {
  const { can, domains } = useAccount();
  if (!can(domain)) return <Navigate to={firstAccessibleRoute(domains) ?? '/'} replace />;
  return <>{children}</>;
};
